import { render, staticRenderFns } from "./VerifiableCredential.vue?vue&type=template&id=9def9136&scoped=true&"
import script from "./VerifiableCredential.vue?vue&type=script&lang=js&"
export * from "./VerifiableCredential.vue?vue&type=script&lang=js&"
import style0 from "./VerifiableCredential.vue?vue&type=style&index=0&id=9def9136&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9def9136",
  null
  
)

export default component.exports